import { animation } from "project-config/style";
import styled, { SimpleInterpolation } from "styled-components";
import { Space } from "task-eva-ui";

export const ModalWrapper = styled.div<{ css?: SimpleInterpolation }>`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 4px;
  border: 1px solid #343538;
  background: #292b2f;
  padding-bottom: 52px;
  .render-modal-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    flex: 1;
    text-align: center;
  }
  ${(p) => p.css};
`;

export const ModalTitle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 14px;
  color: #e0edef;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  background: #18191b;
  border: 1px solid #343538;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  > svg {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
  }
`;

export const WarningTip = styled.div`
  width: 100%;
  min-height: 23px;
  background: #34363b;
  padding: 8px 14px;
  color: #adbdc0;
  display: flex;
  line-height: 12px;
  > svg {
    margin-right: 3px;
  }
`;

export const ModalFooter = styled(Space)`
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translate(-50%, 0);
  button {
    min-width: 86px;
    height: 28px;
  }
  .confirm-button {
    svg {
      margin-left: 5px;
      ${animation("rotate")};
    }
  }
`;
